import { useComponentVisibility } from "~/composables/useComponentVisibility"

export default defineNuxtPlugin( () => {
  return {
    provide: {
      useComponentVisibility
    },
  }
} )
